export const commissionBonusesEn = {
  COMMISSION_BONUSES: 'Commission Bonuses',
  BONUS_TYPE: 'Bonus Type',
  BONUS_AMOUNT: 'Bonus Amount',
  FIRST_FUNDING: 'First Funding',
  THRESHOLD: 'Threshold',
  PARTNER_USER: 'Partner User',
  TEMPLATE_NAME: 'Template Name',
  TRIGGER_DATE: 'Date',
  PAID: 'Paid',
  UNPAID: 'Unpaid',
  MARK_AS_PAID: 'Mark as Paid',
  MARK_AS_UNPAID: 'Mark as Unpaid',
  MARKED_AS_PAID: 'Marked as Paid',
  MARKED_AS_UNPAID: 'Marked as Unpaid',
  VIEW_HISTORY: 'View History',
  BONUS_HISTORY: 'Bonus History',
  CONFIRM_MARK_AS_PAID: 'Are you sure you want to mark this bonus as paid?',
  CONFIRM_MARK_AS_UNPAID: 'Are you sure you want to mark this bonus as unpaid?',
  BONUS_PAID_SUCCESSFULLY: 'Bonus marked as paid successfully',
  BONUS_UNPAID_SUCCESSFULLY: 'Bonus marked as unpaid successfully',
  PAID_BY: 'Paid By',
  PAID_AT: 'Paid At',
  NO_HISTORY: 'No history available',
  FILTER_BY_PARTNER: 'Filter by Partner',
  FILTER_BY_COMPANY: 'Filter by Company',
  FILTER_BY_TYPE: 'Filter by Type',
  FILTER_BY_TEMPLATE: 'Filter by Template',
}

export const commissionBonusesEs: typeof commissionBonusesEn = {
  COMMISSION_BONUSES: 'Bonos de Comisión',
  BONUS_TYPE: 'Tipo de Bono',
  BONUS_AMOUNT: 'Monto del Bono',
  FIRST_FUNDING: 'Primera Financiación',
  THRESHOLD: 'Umbral',
  PARTNER_USER: 'Usuario Socio',
  TEMPLATE_NAME: 'Nombre de Plantilla',
  TRIGGER_DATE: 'Fecha',
  PAID: 'Pagado',
  UNPAID: 'No Pagado',
  MARK_AS_PAID: 'Marcar como Pagado',
  MARK_AS_UNPAID: 'Marcar como No Pagado',
  MARKED_AS_PAID: 'Marcado como Pagado',
  MARKED_AS_UNPAID: 'Marcado como No Pagado',
  VIEW_HISTORY: 'Ver Historial',
  BONUS_HISTORY: 'Historial de Bono',
  CONFIRM_MARK_AS_PAID: '¿Estás seguro de que quieres marcar este bono como pagado?',
  CONFIRM_MARK_AS_UNPAID: '¿Estás seguro de que quieres marcar este bono como no pagado?',
  BONUS_PAID_SUCCESSFULLY: 'Bono marcado como pagado exitosamente',
  BONUS_UNPAID_SUCCESSFULLY: 'Bono marcado como no pagado exitosamente',
  PAID_BY: 'Pagado Por',
  PAID_AT: 'Pagado En',
  NO_HISTORY: 'No hay historial disponible',
  FILTER_BY_PARTNER: 'Filtrar por Socio',
  FILTER_BY_COMPANY: 'Filtrar por Empresa',
  FILTER_BY_TYPE: 'Filtrar por Tipo',
  FILTER_BY_TEMPLATE: 'Filtrar por Plantilla',
}
